// Upcoming events for the front page, from the database (with a temporary fallback to the old hardcoded list).
// Without Firebase dependencies so the rules can be unit tested.
//
// - An event with a date is upcoming until that date has passed.
// - An event without a date is upcoming only if its quarter hasn't started yet (e.g. "KL in 2027 Q1").

import { typeInfo } from './eventTypes';

const startOfDay = (d) => {
  const copy = new Date(d);
  copy.setHours(0, 0, 0, 0);
  return copy;
};

// "2027 Q1" -> first day of the quarter
export function quarterStart(kvartal = '') {
  const [year, q] = kvartal.trim().split(' ');
  const n = parseInt((q || '').replace('Q', ''), 10);
  return year && n ? new Date(parseInt(year, 10), (n - 1) * 3, 1) : null;
}

// "2026-11-28" -> "2026 Q4"
export const quarterOf = (isoDate) => {
  const d = new Date(isoDate);
  return `${d.getFullYear()} Q${Math.floor(d.getMonth() / 3) + 1}`;
};

export function isUpcoming(event, today = new Date()) {
  const day = startOfDay(today);
  if (event.date) return startOfDay(event.date) >= day;
  const start = quarterStart(event.Kvartal);
  return !!start && start > day;
}

// Database event -> card for the front page
export function fromDb(event) {
  const { emoji, label, color } = typeInfo(event.event_type);
  return {
    key: `db-${event.id}`,
    icon: emoji || '✦',
    typeLabel: label,
    color,
    title: (event.sted_konsept || '').trim() || label,
    date: event.date ? new Date(event.date) : null,
    quarter: event.Kvartal,
    desc: event.description || '',
    location: event.location || '',
    hosts: (event.Vert || []).join(' & '),
    tags: event.tags || [],
    eventType: event.event_type,
  };
}

// Upcoming database events, plus old hardcoded ones that have no database event in the same type and quarter yet
export function mergeUpcoming(dbEvents, legacyCards, today = new Date()) {
  const fromDatabase = dbEvents.filter(e => isUpcoming(e, today)).map(fromDb);
  const taken = new Set(fromDatabase.map(c => `${c.typeLabel}|${c.quarter}`));
  const legacy = legacyCards.filter(c => isUpcoming({ date: c.date, Kvartal: c.quarter }, today)
    && !taken.has(`${c.typeLabel}|${c.quarter}`));
  const when = (c) => (c.date ? startOfDay(c.date) : quarterStart(c.quarter));
  return [...fromDatabase, ...legacy].sort((a, b) => when(a) - when(b));
}
